import { map } from 'lodash';
import { setBusy, setUnBusy } from './common/commonReducers';
import {
  SlackAccount,
  SlackModel,
  SlackChannelsById,
} from '../model/SlackModel';
import SlackCRUDActions from '../actions/SlackCRUDActions';

type ActionType = {
  type: string;
  accounts: SlackAccount[];
  channels: SlackChannelsById;
  accountsId: number[];
};

const initialState: SlackModel = {
  busy: false,
  accounts: [],
  accountsId: [],
  channelsById: null,
};

export const slack = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case SlackCRUDActions.busyAction:
      return setBusy(state);
    case SlackCRUDActions.retrieveOauthUrlAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case SlackCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: action.accounts,
        accountsId: map(action.accounts, 'id'),
        busy: false,
      };
    }
    case SlackCRUDActions.retrieveChannels: {
      return {
        ...state,
        channelsById: action.channels,
        busy: false,
      };
    }
    case SlackCRUDActions.revokeAccess: {
      return {
        ...state,
        busy: false,
      };
    }
    case SlackCRUDActions.resetStore: {
      return initialState;
    }
    case SlackCRUDActions.unbusyAction:
      return setUnBusy(state);
    default:
      return state;
  }
};
